import {createReducer} from '@reduxjs/toolkit';
import {uniqBy} from 'lodash';
import {getProjects, updateProject} from './actions';
import {ProjectDto} from '../../../dto/ProjectDto';

const initialState: ProjectDto[] = [];

export const projects = createReducer(initialState, (builder) =>
    builder
        .addCase(getProjects.fulfilled, (state, action) => uniqBy([...state, ...action.payload], 'projectId'))
        .addCase(updateProject.fulfilled, (state, action) =>
            state.map((project) => (project.projectId === action.payload.projectId ? action.payload : project))
        )
);
